import React, { useState } from "react";
import TableFilterAdvanced from "../../components/TableFilterAdvanced";
import { Button } from "primereact/button";
import styled from "./index.module.css";
import { DataTablePageEvent, DataTableSortEvent } from "primereact/datatable";

const errorProofList = [
  {
    id: "1",
    op: "OP10",
    descricao: "Fixação do suporte lateral",
    action: "Adição de pino de centragem",
    FMEA: "FMEA-1",
    dataImplementacao: "2025-06-10",
  },
  {
    id: "2",
    op: "OP10",
    descricao: "Fixação do suporte lateral",
    action: "Aplicação de trava roscada automática",
    FMEA: "FMEA-1",
    dataImplementacao: "2025-07-03",
  },
  {
    id: "3",
    op: "OP20",
    descricao: "Montagem do Kit",
    action: "Instalação de sensor infravermelho",
    FMEA: "FMEA-1",
    dataImplementacao: "2025-06-30",
  },
  {
    id: "4",
    op: "OP20",
    descricao: "Montagem do Kit",
    action: "Reposicionamento da bancada para ergonomia",
    FMEA: "FMEA-12",
    dataImplementacao: "2025-07-04",
  },
  {
    id: "5",
    op: "OP30",
    descricao: "Torque da tampa",
    action: "Ajuste na parametrização do controlador de torque",
    FMEA: "FMEA-2",
    dataImplementacao: "2025-07-01",
  },
  {
    id: "6",
    op: "OP30",
    descricao: "Torque da tampa",
    action: "Inclusão de verificação dupla com checklist digital",
    FMEA: "FMEA-2",
    dataImplementacao: "2025-07-05",
  },
  {
    id: "7",
    op: "OP40",
    descricao: "Aplicação de vedante",
    action: "Instalação de dosador com temporização",
    FMEA: "FMEA-2",
    dataImplementacao: "2025-06-28",
  },
  {
    id: "8",
    op: "OP60",
    descricao: "Ajuste final da peça",
    action: "Implementação de controle visual padrão",
    FMEA: "FMEA-3",
    dataImplementacao: "2025-07-06",
  },
  {
    id: "9",
    op: "OP70",
    descricao: "Montagem do eixo",
    action: "Instalação de limitador de curso mecânico",
    FMEA: "FMEA-4",
    dataImplementacao: "2025-06-25",
  },
  {
    id: "10",
    op: "OP80",
    descricao: "Inspeção dimensional",
    action: "Inclusão de checklist eletrônico por operador",
    FMEA: "FMEA-4",
    dataImplementacao: "2025-07-02",
  },
  {
    id: "11",
    op: "OP100",
    descricao: "Aplicação de etiqueta",
    action: "Criação de erro proof com leitura óptica do código",
    FMEA: "FMEA-5",
    dataImplementacao: "2025-07-07",
  },
  {
    id: "12",
    op: "OP110",
    descricao: "Teste funcional elétrico",
    action: "Instalação de sensor de presença do conector",
    FMEA: "FMEA-6",
    dataImplementacao: "2025-07-04",
  },
];

const ListErrorProof: React.FC = () => {
  const [data] = useState(errorProofList);
  const [page, setPage] = useState(0);
  const [rows] = useState(10);
  const [sortField, setSortField] = useState<string>("op");
  const [sortOrder, setSortOrder] = useState<1 | -1>(1);

  const columns = [
    { field: "op", header: "OP" },
    { field: "descricao", header: "Descrição" },
    { field: "action", header: "Ação Realizada" },
    { field: "FMEA", header: "FMEA" },
    { field: "dataImplementacao", header: "Data de Implementação" },
  ];

  return (
    <>
      <div
        className={styled.container}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <h2 className={styled.title}>Lista Error Proof</h2>

        <div className={styled.metadata}>
          <p>
            <strong>Área:</strong> Montagem
          </p>
          <p>
            <strong>Linha:</strong> MOTOR
          </p>
          <p>
            <strong>Sublinha:</strong> Motor A2
          </p>
        </div>
      </div>
      <div
        className={styled.actions}
        style={{
          position: "absolute",
          top: "0",
          right: "0",
          transform: "translate(-20%, 295px)",
          zIndex: 1000,
          backgroundColor: "#fff",
        }}
      >
        <Button label="Exportar" className="p-button-success" />
      </div>
      <div
        style={{
          width: "100%",
          background: "gray",
          height: "2px",
          marginBottom: "2rem",
        }}
      />

      <TableFilterAdvanced
        data={data}
        columns={columns}
        loading={false}
        totalRecords={data.length}
        first={page}
        rows={rows}
        onFilter={() => {}}
        onPage={(e: DataTablePageEvent) => setPage(e.first)}
        onSorts={(e: DataTableSortEvent) => {
          setSortField(e.sortField!);
          if (e.sortOrder === 1 || e.sortOrder === -1) {
            setSortOrder(e.sortOrder);
          }
        }}
        sortField={sortField}
        sortOrder={sortOrder}
      />
    </>
  );
};

export default ListErrorProof;
